/** The screens the Android renderer draws per payload type — the pane's Screen select. */
import type { PreviewApiType } from '@/api/mobilePreview';

import type { RendererScreen } from '../../types';

export const TRIP_SCREEN = 'trip';
export const MY_TRIPS_SCREEN = 'my-trips';

export function androidScreens(apiType: PreviewApiType): RendererScreen[] {
  if (apiType === 'tour_template') {
    return [
      { id: TRIP_SCREEN, label: 'Trip' },
      { id: MY_TRIPS_SCREEN, label: 'My Bookings card' },
    ];
  }
  return [];
}
